export default __webpack_public_path__ + "static/media/GUIÓN SIMULADOR PUNCIÓN_3.8df1a172.mp3";